import React, { CSSProperties, useMemo } from 'react';
import cls from 'classnames';
import type { IconName } from './icon-names';
import style from './Icon.module.pcss';

export type { IconName };
export type IconSize =
  | '12'
  | '14'
  | '16'
  | '18'
  | '20'
  | '24'
  | '32'
  | '40'
  | '48'
  | '64';

export interface Props {
  icon: IconName;
  size: IconSize;
  title?: string;
  className?: string;
  spin?: boolean;
  extraProps?: Record<string, unknown>;
  onClick?(e: React.MouseEvent<HTMLSpanElement>): void;
  style?: CSSProperties;
  testId?: string;
  id?: string;
}

const Icon = (props) => {
  const IconComponent = React.lazy(
    () => import(/* webpackChunkName: 'svg' */ `./icons/${props.icon}.svg`)
  );

  const fallbackStyle = useMemo(
    () => ({
      width: `${props.size}px`,
      height: `${props.size}px`,
    }),
    [props.size]
  );

  return (
    <span
      title={props.title}
      className={cls(style.Icon, props.className, { [style.spin]: props.spin })}
      onClick={props.onClick}
      style={props.style}
      {...props.extraProps}
      data-testid={props.testId}
      id={props.id}
    >
      <React.Suspense fallback={<span style={fallbackStyle} />}>
        <IconComponent
          className="icon-comp"
          width={props.size}
          height={props.size}
        />
      </React.Suspense>
    </span>
  );
};

export const NonMemoIcon = Icon;
export default React.memo(Icon);
